module.exports = __webpack_public_path__ + "../resources/img/ic-plus.cd4624f2.svg";